import { FC, useCallback } from 'react';

import { IndicatorVariants } from '@formstack/phoenix/components/Indicator/constants';
import { Toast as PhoenixToast } from '@formstack/phoenix/components/Toast';

import { useAppDispatch, useAppSelector } from '@/store/app.hooks';
import { clearToast, toast } from '@/store/common/toast/slice';

export const Toast: FC = () => {
  const dispatch = useAppDispatch();
  const { message, showToast, variant = IndicatorVariants.success } = useAppSelector(toast);

  const closeToast = useCallback(() => dispatch(clearToast()), [dispatch]);

  return (
    <PhoenixToast
      message={message}
      closeAction={closeToast}
      showToast={showToast}
      variant={variant}
    />
  );
};
